import React from 'react';

import LanguageSelector from './languageSelector/LanguageSelector';
import {
    isMobile
} from "react-device-detect";
import Icon from "@material-ui/core/Icon";
import HelpIcon from '@material-ui/icons/HelpOutline';
import LayoutTypeEnum from "../../config/constants/LayoutTypeEnum";
import CloseIcon from '@material-ui/icons/Close';
import MinimizeIcon from '@material-ui/icons/Minimize';
import FullIcon from '@material-ui/icons/AspectRatio';
import Button from "@material-ui/core/Button";
import Localization from "../../config/localization/Localization";
import {getLocalizationLanguageCode} from "../../util/localization";

const TopBar = (props) => {
    return (
        <div id={'top-bar-menu'} style={{backgroundColor: props.backgroundColor    && ( props.showInfo || isMobile ) ? props.backgroundColor : "transparent", color: props.color ? props.color : "black" }}>
            {(props.layoutMode==null || props.layoutMode !== LayoutTypeEnum.searchBot) &&  props.avatar?

                <div id={'top-bar-info'} style={{  display: (props.showInfo ) == false ?'none':null }}>
                    <div id={'top-bar-info-avatar'}>
                        <img src={props.avatar}
                             alt="avatar"/></div>
                    <div id={'top-bar-info-text'}>
                        <div id={'top-bar-info-name'} style={{
                            font: props.font,
                            fontWeight: "bold"
                        }}>{props.name}</div>
                        <div id={'top-bar-info-description'} style={{
                            font: props.font
                        }}>{props.clientDescription}</div>
                    </div>

                </div> : null
            }

            {/*{this.props.showInfo == false ? <div id={'powered-by-container'}>*/}
            {/*    <a href={'https://inchatbot.com'} target={'_blank'}>*/}
            {/*        <span>Powered by InChatbot</span>*/}
            {/*    </a>*/}
            {/*</div> : null*/}
            {/*}*/}


            <LanguageSelector isSearch={false} language={props.language}
                              languageList={props.languageList}
                              languageSelected={props.languageSelected}/>
            {isMobile == false && props.enableMaximize && <Button id={'maxi-chatbot-button'} tabIndex="6" title={Localization[getLocalizationLanguageCode(props.language ? props.language.languageCode : null)]['topBar.title.mini']} onClick={() => props.toggleMaxiChatbot()}>
                     {props.isMaximized ?
                        <MinimizeIcon />
                        :<FullIcon  />
                    }
            </Button> }
            <Button title={Localization[getLocalizationLanguageCode(props.language ? props.language.languageCode : null)]['topBar.title.help']} tabIndex="7" id={'info-page-toggle-button'} onClick={() => props.toggleShowInfoPage()}>
                    <HelpIcon  />
            </Button>
            <Button title={Localization[getLocalizationLanguageCode(props.language ? props.language.languageCode : null)]['topBar.title.close']} tabIndex="8" id={'close-chatbot-button'} onClick={() =>  props.closeChatbot()}>
                    <CloseIcon  />
            </Button>
        </div>
    );
};

export default TopBar;